import { PushpinFilled, SafetyCertificateFilled, SafetyCertificateOutlined } from "@ant-design/icons"

export const WebView = (props:{url: string, strike?: boolean}) => {

  return (
    <div className="url-box">
        <div style={{margin: "1em 0 0 0", display:"flex",justifyContent:"flex-start"}}>
        {props.strike ?          
            <del style={{ color: "darkred" }}>
                {props.url || '(Sin web)'} <PushpinFilled/>
            </del>
            :
            <span style={{ color: "slategrey" }}>
              {props.url || '(Sin web)'}
          </span>
        }
        </div>
</div>
  )
}
